<div class="user-management">
  <!-- Header Section -->
  <div class="page-header">
    <div class="header-content">
      <div class="header-left">
        <h1 class="page-title">
          <i class="fas fa-users"></i>
          User Management
        </h1>
        <p class="page-subtitle">Manage users, roles, and permissions</p>
      </div>
      <div class="header-actions">
        <!-- <button class="btn btn-primary" (click)="openCreateModal()" 
                [disabled]="!canManageAdmins && !canManageSuperAdmins">
          <i class="fas fa-plus"></i>
          Add New User
        </button> -->
      </div>
    </div>
  </div>

  <!-- Statistics Cards -->
  <div class="stats-grid">
    <div class="stat-card">
      <div class="stat-icon">
        <i class="fas fa-users"></i>
      </div>
      <div class="stat-content">
        <h3>{{ statistics.totalUsers }}</h3>
        <p>Total Users</p>
      </div>
    </div>
    
    <div class="stat-card">
      <div class="stat-icon">
        <i class="fas fa-user-shield"></i>
      </div>
      <div class="stat-content">
        <h3>{{ statistics.totalAdmins }}</h3>
        <p>Admins</p>
      </div>
    </div>
    
    <!-- <div class="stat-card">
      <div class="stat-icon">
        <i class="fas fa-crown"></i>
      </div>
      <div class="stat-content">
        <h3>{{ statistics.totalSuperAdmins }}</h3>
        <p>Super Admins</p>
      </div>
    </div> -->
    
    <div class="stat-card">
      <div class="stat-icon">
        <i class="fas fa-user-check"></i>
      </div>
      <div class="stat-content">
        <h3>{{ statistics.activeUsers }}</h3>
        <p>Active Users</p>
      </div>
    </div>
  </div>

  <!-- Search and Filters Section -->
  <div class="filters-section">
    <div class="filters-grid">
      <div class="search-box">
        <div class="input-group">
          <span class="input-group-text">
            <i class="fas fa-search"></i>
          </span>
          <input type="text" class="form-control" placeholder="Search users by name, email, or mobile..."
            [(ngModel)]="searchTerm" (input)="applyFilter($event)">
        </div>
      </div>

      <div class="filter-controls">
        <select class="form-select" [(ngModel)]="selectedRole" (change)="onRoleFilterChange()">
          <option value="all">All Roles</option>
          <option value="user">Users</option>
          <option value="admin">Admins</option>
          <option value="super_admin">Super Admins</option>
        </select>

        <button class="btn btn-outline-secondary" (click)="loadUsers()">
          <i class="fas fa-sync-alt"></i>
          Refresh
        </button>
      </div>
    </div>
  </div>

  <!-- Loading State -->
  @if (loading && currentPage === 1) {
  <div class="loading-state">
    <div class="spinner"></div>
    <p>Loading users...</p>
  </div>
  }

  <!-- Users Table -->
  @if (!loading || currentPage > 1) {
  <div class="users-table-container">
    <div class="table-header">
      <div class="table-info">
        <span class="total-count">{{ filteredUsers.length }} users found</span>
      </div>
    </div>

    @if (filteredUsers.length === 0 && !loading) {
    <div class="no-users">
      <i class="fas fa-users fa-3x"></i>
      <h3>No users found</h3>
      <p>Try adjusting your search criteria or add a new user.</p>
      <button class="btn btn-primary" (click)="openCreateModal()">
        <i class="fas fa-plus"></i>
        Add First User
      </button>
    </div>
    } @else {
    <div class="table-responsive">
      <table class="table table-hover" id="usersTable">
        <thead class="table-header">
          <tr>
            <th data-sortable="true" data-field="name">
              <div class="sortable-header" (click)="sortTable('name')">
                User
                <i class="fas fa-sort sort-icon" [class]="getSortIconClass('name')"></i>
              </div>
            </th>
            <th data-sortable="true" data-field="mobile">
              <div class="sortable-header" (click)="sortTable('mobile')">
                Contact
                <i class="fas fa-sort sort-icon" [class]="getSortIconClass('mobile')"></i>
              </div>
            </th>
            <th data-sortable="true" data-field="role">
              <div class="sortable-header" (click)="sortTable('role')">
                Role
                <i class="fas fa-sort sort-icon" [class]="getSortIconClass('role')"></i>
              </div>
            </th>
            <th data-sortable="true" data-field="status">
              <div class="sortable-header" (click)="sortTable('status')">
                Status
                <i class="fas fa-sort sort-icon" [class]="getSortIconClass('status')"></i>
              </div>
            </th>
            <th data-sortable="true" data-field="registrationDate">
              <div class="sortable-header" (click)="sortTable('registrationDate')">
                Registration
                <i class="fas fa-sort sort-icon" [class]="getSortIconClass('registrationDate')"></i>
              </div>
            </th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          @for (user of paginatedUsers; track user.id) {
          <tr class="user-row">
            <td class="user-info">
              <div class="user-details">
                <h4 class="user-name">{{ user.name }}</h4>
                <div class="user-meta">
                  <span class="user-id">
                    <i class="fas fa-hashtag me-1"></i>
                    ID: {{ user.id }}
                  </span>
                </div>
              </div>
            </td>

            <td class="contact-info">
              <div class="contact-item">
                <i class="fas fa-phone"></i>
                <span class="contact-text">{{ user.mobile }}</span>
                <button class="btn btn-sm btn-outline-secondary copy-btn" 
                        (click)="copyToClipboard(user.mobile, 'Mobile')" 
                        title="Copy Mobile">
                  <i class="fas fa-copy"></i>
                </button>
              </div>
              <div class="contact-item">
                <i class="fas fa-envelope"></i>
                <span class="contact-text">{{ user.email }}</span>
                <button class="btn btn-sm btn-outline-secondary copy-btn" 
                        (click)="copyToClipboard(user.email, 'Email')" 
                        title="Copy Email">
                  <i class="fas fa-copy"></i>
                </button>
              </div>
              @if (user.altMobile) {
              <div class="contact-item">
                <i class="fas fa-mobile-alt"></i>
                <span class="contact-text">{{ user.altMobile }}</span>
              </div>
              }
            </td>

            <td class="role-info">
              <div class="role-badge" [ngClass]="getRoleBadgeClass(user.role)">
                <i [class]="user.role === 'super_admin' ? 'fas fa-crown' : user.role === 'admin' ? 'fas fa-user-shield' : 'fas fa-user'"></i>
                {{ user.role | titlecase }}
              </div>
            </td>

            <td class="status-info">
              <div class="status-badge" [ngClass]="getStatusBadgeClass(user)">
                <i [class]="(user.status || 'active') === 'active' ? 'fas fa-toggle-on' : 'fas fa-toggle-off'"></i>
                {{ user.status || 'active' | titlecase }}
              </div>
            </td>

            <td class="registration-info">
              <div class="registration-date">
                <i class="fas fa-calendar-alt me-1"></i>
                {{ formatDate(user.registrationDate) }}
              </div>
            </td>

            <td class="actions">
              @if (canManageUser(user)) {
              <div class="action-buttons">
                <button class="btn btn-sm btn-outline-primary" (click)="openEditModal(user)"
                  title="Edit User">
                  <i class="fas fa-edit"></i>
                </button>

                @if (canChangeUserRole(user)) {
                <button class="btn btn-sm btn-outline-warning" (click)="openRoleModal(user)"
                  title="Change Role">
                  <i class="fas fa-user-shield"></i>
                </button>
                }

                <button class="btn btn-sm btn-outline-info" (click)="openStatusModal(user)"
                  title="Toggle Status">
                  <i class="fas fa-toggle-on"></i>
                </button>

                <button class="btn btn-sm btn-outline-danger" (click)="openDeleteModal(user)"
                  [disabled]="user.id === currentUser?.id"
                  title="Delete User">
                  <i class="fas fa-trash"></i>
                </button>
              </div>
              } @else {
              <span class="no-permission">No permission</span>
              }
            </td>
          </tr>
          }
        </tbody>
      </table>
    </div>

    <!-- Data Table Pagination -->
    <div class="pagination-container">
      <div class="pagination-info">
        <span>Showing {{ startIndex + 1 }}-{{ endIndex }} of {{ filteredUsers.length }} users</span>
      </div>
      
      <div class="pagination-controls">
        <button class="btn btn-outline-secondary" 
                (click)="previousPage()" 
                [disabled]="currentPage === 1">
          <i class="fas fa-chevron-left"></i>
          Previous
        </button>
        
        <div class="page-numbers">
          @for (page of getPageNumbers(); track page) {
          <button class="btn btn-outline-primary page-btn" 
                  [class.active]="page === currentPage"
                  (click)="goToPage(page)"
                  [disabled]="page === '...'">
            {{ page }}
          </button>
          }
        </div>
        
        <button class="btn btn-outline-secondary" 
                (click)="nextPage()" 
                [disabled]="currentPage === totalPages">
          Next
          <i class="fas fa-chevron-right"></i>
        </button>
      </div>
      
      <div class="page-size-controls">
        <label>Show:</label>
        <select class="form-select" [(ngModel)]="pageSize" (change)="onPageSizeChange()">
          <option value="10">10</option>
          <option value="25">25</option>
          <option value="50">50</option>
          <option value="100">100</option>
        </select>
        <span>per page</span>
      </div>
    </div>
    }
  </div>
}

<!-- Create User Modal -->
@if (showCreateModal) {
<div class="modal-overlay" (click)="closeCreateModal()">
  <div class="modal-content" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h3>Create New User</h3>
      <button class="modal-close" (click)="closeCreateModal()">
        <i class="fas fa-times"></i>
      </button>
    </div>
    
    <form [formGroup]="createUserForm" (ngSubmit)="createUser()" class="modal-body">
      <div class="form-row">
        <div class="form-group">
          <label>Full Name *</label>
          <input type="text" class="form-control" formControlName="name" placeholder="Enter full name">
          @if (createUserForm.get('name')?.invalid && createUserForm.get('name')?.touched) {
          <div class="error-message">Name is required and must be at least 2 characters</div>
          }
        </div>
        
        <div class="form-group">
          <label>Mobile Number *</label>
          <input type="text" class="form-control" formControlName="mobile" placeholder="Enter 10-digit mobile number">
          @if (createUserForm.get('mobile')?.invalid && createUserForm.get('mobile')?.touched) {
          <div class="error-message">Valid 10-digit mobile number is required</div>
          }
        </div>
      </div>
      
      <div class="form-row">
        <div class="form-group">
          <label>Email *</label>
          <input type="email" class="form-control" formControlName="email" placeholder="Enter email address">
          @if (createUserForm.get('email')?.invalid && createUserForm.get('email')?.touched) {
          <div class="error-message">Valid email address is required</div>
          }
        </div>
        
        <div class="form-group">
          <label>Password *</label>
          <input type="password" class="form-control" formControlName="password" placeholder="Enter password">
          @if (createUserForm.get('password')?.invalid && createUserForm.get('password')?.touched) {
          <div class="error-message">Password must be at least 6 characters</div>
          }
        </div>
      </div>
      
      <div class="form-row">
        <div class="form-group">
          <label>Gender *</label>
          <select class="form-control" formControlName="gender">
            <option value="male">Male</option>
            <option value="female">Female</option>
            <option value="other">Other</option>
          </select>
        </div>
        
        <div class="form-group">
          <label>Role *</label>
          <select class="form-control" formControlName="role">
            <option value="user">User</option>
            @if (canManageAdmins()) {
            <option value="admin">Admin</option>
            }
            @if (canManageSuperAdmins()) {
            <option value="super_admin">Super Admin</option>
            }
          </select>
        </div>
      </div>
      
      <div class="form-group">
        <label>Date of Birth *</label>
        <input type="date" class="form-control" formControlName="dateOfBirth">
      </div>
      
      <div class="form-group">
        <label>Full Address *</label>
        <textarea class="form-control" formControlName="fullAddress" placeholder="Enter full address" rows="3"></textarea>
      </div>
      
      <div class="form-group">
        <label>Alternative Mobile</label>
        <input type="text" class="form-control" formControlName="altMobile" placeholder="Enter alternative mobile number">
      </div>
    </form>
    
    <div class="modal-footer">
      <button class="btn btn-secondary" (click)="closeCreateModal()">Cancel</button>
      <button class="btn btn-primary" (click)="createUser()" [disabled]="createUserForm.invalid">
        Create User
      </button>
    </div>
  </div>
</div>
}

<!-- Edit User Modal -->
@if (showEditModal) {
<div class="modal-overlay" (click)="closeEditModal()">
  <div class="modal-content" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h3>Edit User: {{ selectedUser?.name }}</h3>
      <button class="modal-close" (click)="closeEditModal()">
        <i class="fas fa-times"></i>
      </button>
    </div>
    
    <form [formGroup]="editUserForm" (ngSubmit)="updateUser()" class="modal-body">
      <div class="form-row">
        <div class="form-group">
          <label>Full Name *</label>
          <input type="text" class="form-control" formControlName="name" placeholder="Enter full name">
        </div>
        
        <div class="form-group">
          <label>Email *</label>
          <input type="email" class="form-control" formControlName="email" placeholder="Enter email address">
        </div>
      </div>
      
      <div class="form-row">
        <div class="form-group">
          <label>Gender *</label>
          <select class="form-control" formControlName="gender">
            <option value="male">Male</option>
            <option value="female">Female</option>
            <option value="other">Other</option>
          </select>
        </div>
        
        <div class="form-group">
          <label>Role *</label>
          <select class="form-control" formControlName="role">
            <option value="user">User</option>
            @if (canManageAdmins()) {
            <option value="admin">Admin</option>
            }
            @if (canManageSuperAdmins()) {
            <option value="super_admin">Super Admin</option>
            }
          </select>
        </div>
      </div>
      
      <div class="form-group">
        <label>Date of Birth *</label>
        <input type="date" class="form-control" formControlName="dateOfBirth">
      </div>
      
      <div class="form-group">
        <label>Full Address *</label>
        <textarea class="form-control" formControlName="fullAddress" placeholder="Enter full address" rows="3"></textarea>
      </div>
      
      <div class="form-group">
        <label>Alternative Mobile</label>
        <input type="text" class="form-control" formControlName="altMobile" placeholder="Enter alternative mobile number">
      </div>
    </form>
    
    <div class="modal-footer">
      <button class="btn btn-secondary" (click)="closeEditModal()">Cancel</button>
      <button class="btn btn-primary" (click)="updateUser()" [disabled]="editUserForm.invalid">
        Update User
      </button>
    </div>
  </div>
</div>
}

<!-- Delete User Modal -->
@if (showDeleteModal) {
<div class="modal-overlay" (click)="closeDeleteModal()">
  <div class="modal-content" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h3>Delete User</h3>
      <button class="modal-close" (click)="closeDeleteModal()">
        <i class="fas fa-times"></i>
      </button>
    </div>
    
    <div class="modal-body">
      <div class="delete-warning">
        <i class="fas fa-exclamation-triangle"></i>
        <p>Are you sure you want to delete <strong>{{ selectedUser?.name }}</strong>?</p>
        <p class="warning-text">This action cannot be undone. All user data will be permanently removed.</p>
      </div>
    </div>
    
    <div class="modal-footer">
      <button class="btn btn-secondary" (click)="closeDeleteModal()">Cancel</button>
      <button class="btn btn-danger" (click)="deleteUser()">
        <i class="fas fa-trash"></i>
        Delete User
      </button>
    </div>
  </div>
</div>
}

<!-- Change Role Modal -->
@if (showRoleModal) {
<div class="modal-overlay" (click)="closeRoleModal()">
  <div class="modal-content" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h3>Change User Role</h3>
      <button class="modal-close" (click)="closeRoleModal()">
        <i class="fas fa-times"></i>
      </button>
    </div>
    
    <div class="modal-body">
      <p>Change role for <strong>{{ selectedUser?.name }}</strong></p>
      <p>Current role: <span class="badge" [class]="getRoleBadgeClass(selectedUser?.role || 'user')">{{ selectedUser?.role | titlecase }}</span></p>
      
      <div class="role-options">
        <button class="btn btn-outline-primary" 
                (click)="changeUserRole('user')"
                [class.active]="selectedUser?.role === 'user'">
          <i class="fas fa-user"></i>
          User
        </button>
        
        @if (canChangeUserRole(selectedUser!)) {
        <button class="btn btn-outline-warning" 
                (click)="changeUserRole('admin')"
                [class.active]="selectedUser?.role === 'admin'">
          <i class="fas fa-user-shield"></i>
          Admin
        </button>
        }
      </div>
    </div>
    
    <div class="modal-footer">
      <button class="btn btn-secondary" (click)="closeRoleModal()">Cancel</button>
    </div>
  </div>
</div>
}

<!-- Toggle Status Modal -->
@if (showStatusModal) {
<div class="modal-overlay" (click)="closeStatusModal()">
  <div class="modal-content" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h3>Toggle User Status</h3>
      <button class="modal-close" (click)="closeStatusModal()">
        <i class="fas fa-times"></i>
      </button>
    </div>
    
    <div class="modal-body">
      <p>Change status for <strong>{{ selectedUser?.name }}</strong></p>
      <p>Current status: <span class="badge" [class]="getStatusBadgeClass(selectedUser!)">{{ selectedUser?.status || 'active' | titlecase }}</span></p>
      
      <div class="status-options">
        <button class="btn btn-outline-success" 
                (click)="toggleUserStatus(true)"
                [class.active]="selectedUser?.status !== 'inactive'">
          <i class="fas fa-check-circle"></i>
          Activate
        </button>
        
        <button class="btn btn-outline-danger" 
                (click)="toggleUserStatus(false)"
                [class.active]="selectedUser?.status === 'inactive'">
          <i class="fas fa-times-circle"></i>
          Deactivate
        </button>
      </div>
    </div>
    
    <div class="modal-footer">
      <button class="btn btn-secondary" (click)="closeStatusModal()">Cancel</button>
    </div>
  </div>
</div>
}
